var PRICEBREAKDOWN_ITEM_TYPE = {
    BAGGAGES: 'BAGGAGES',
    BAGGAGES_WEIGHT: 'BAGGAGES_WEIGHT',
    SERVICE_OPTIONS: 'SERVICE_OPTIONS',
    ADULTS: 'ADULTS',
    CHILDREN: 'CHILDREN',
    INFANTS: 'INFANTS',
    INSURANCE: 'INSURANCE',
    INSURANCE_IN_CART: 'INSURANCE_IN_CART',
    REBOOKING_INSURANCE: 'REBOOKING_INSURANCE',
    CANX_INSURANCE: 'CANX_INSURANCE',
    ASSISTANCE_INSURANCE: 'ASSISTANCE_INSURANCE',
    ADDITION: 'ADDITION',
    SERVICE_FEE: 'SERVICE_FEE',
    CC_FEE: 'CC_FEE',
    DISCOUNT_FEE: 'DISCOUNT_FEE',
    DYNPACK_DISCOUNT_FEE: 'DYNPACK_DISCOUNT_FEE',
    SEAT: 'SEAT',
    SEATMAP: 'SEATMAP',
    PROMO_CODE: 'PROMO_CODE',
    MEMBERSHIP_SUBSCRIPTION: 'MEMBERSHIP_SUBSCRIPTION',
    REPRICING: 'REPRICING',
    HAND_BAGGAGE: 'HAND_BAGGAGE',
    FAST_TRACK: 'AIRPORT_FAST_TRACK',
};

module.exports = PRICEBREAKDOWN_ITEM_TYPE;
